import React from 'react';
import '../../components/HeroSection.css';

const HeroSection = () => {
  // Import the existing HeroSection component
  const OriginalHeroSection = require('../../components/HeroSection').default;
  
  return <OriginalHeroSection />;
};

export default HeroSection; 